import React from "react";
import { Img } from "../Img/Img";
import { TextH } from "../TextH/TextH";
import { TextP } from "../TextP/TextP";
import style from "./C1.module.scss";
import classNames from "classnames";
import { useSignal } from "@preact/signals-react";
export var C1 = function C1(props) {
  var expanded = useSignal(false);
  return /*#__PURE__*/React.createElement("div", {
    className: style.c1Box
  }, /*#__PURE__*/React.createElement(Img, {
    imgKey: props.item.imgKey,
    className: "c1Img",
    expanded: expanded.value
  }), !expanded.value && /*#__PURE__*/React.createElement("div", {
    className: style.backGradient
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(style.textBox, expanded.value ? "" : style.shrink)
  }, /*#__PURE__*/React.createElement(TextH, {
    readonlyStyle: props.readonlyStyle,
    head: props.item.head,
    className: "c1Head",
    expanded: expanded.value
  }), /*#__PURE__*/React.createElement(TextP, {
    readonlyStyle: props.readonlyStyle,
    paragraph: props.item.paragraph,
    className: "c1Paragraph",
    expanded: expanded
  })));
};